export interface Snackbar {
  color: '';
  mode: '';
  snackbar: boolean;
  text: '';
  timeout: 0;
  x: '';
  y: '';
}

export interface SnackbarState {
  snackbar: Snackbar;
}

export const SnackbarModule = {
  state: {
    snackbar: {} as Snackbar,
  },
  mutations: {
    addSnackbar(state: SnackbarState, snackbar: Snackbar) {
      state.snackbar = {...snackbar, snackbar: true};
    },
    closeSnackbar(state: SnackbarState) {
      state.snackbar.snackbar = false;
    },
  },
};
